var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNcplogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 167,
    viewBox: "0 0 52 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9879 164.655C44.8477 164.655 46.6312 163.916 47.9463 162.601C49.2612 161.286 50 159.503 50 157.643V124.057C50 121.671 48.9452 119.407 47.1183 117.872C45.6633 116.65 43.8239 115.98 41.9236 115.98H9.64491C7.63017 115.98 5.72315 116.89 4.45545 118.456C3.49315 119.645 2.96811 121.128 2.96811 122.657V157.467C2.96811 159.434 3.77437 161.316 5.19893 162.672C6.53553 163.945 8.3106 164.655 10.1564 164.655H42.9879Z",
    fill: "#FCDB38",
    stroke: "#201C1C",
    strokeWidth: 3.93904,
    strokeMiterlimit: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4092 136.313C30.2845 136.313 32.3383 135.903 32.3383 132.616C32.3383 129.125 28.8468 129.125 25.9715 129.125H21.2477V136.313H27.4092ZM10.7734 159.521V121.321H28.2307C36.4459 121.115 42.6073 124.401 42.4019 132C42.1965 139.599 38.4997 144.939 29.0522 144.118H21.2477V159.521H10.7734Z",
    fill: "#201C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9494 108.566C47.2085 108.566 49.2623 106.512 49.2623 104.253V63.9982C49.2623 61.7391 47.2085 59.8906 44.9494 59.8906H6.54345C4.07891 59.8906 2.23047 61.7391 2.23047 63.9982V104.253C2.23047 106.512 4.07891 108.566 6.54345 108.566H44.9494Z",
    fill: "#FCDB38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9494 108.566C47.2085 108.566 49.2623 106.512 49.2623 104.253V63.9982C49.2623 61.7391 47.2085 59.8906 44.9494 59.8906H6.54345C4.07891 59.8906 2.23047 61.7391 2.23047 63.9982V104.253C2.23047 106.512 4.07891 108.566 6.54345 108.566H44.9494Z",
    stroke: "#201C1C",
    strokeWidth: 3.93904,
    strokeMiterlimit: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2156 77.9636C32.2156 74.6775 29.3402 72.2129 25.6434 72.2129C21.3304 72.4183 19.2766 77.1421 19.2766 84.3304C19.2766 89.6703 20.7143 95.4209 26.6704 95.4209C30.5726 95.4209 32.4209 92.751 32.8317 89.0541H43.5115C41.663 97.8855 36.3232 104.047 27.0811 104.047C15.3745 104.047 7.77539 97.2694 7.77539 84.7411C7.77539 72.4183 14.7583 64.2031 24.8219 64.2031C35.9124 64.2031 42.4846 69.1322 43.7168 77.9636H32.2156Z",
    fill: "#201C1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.719 50.6751C47.1835 50.6751 49.0319 48.6213 49.0319 46.3622V6.10762C49.0319 3.84843 47.1835 2 44.719 2H6.31298C3.84844 2 2 3.84843 2 6.10762V46.3622C2 48.6213 3.84844 50.6751 6.31298 50.6751H44.719Z",
    fill: "#FCDB38"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.719 50.6751C47.1835 50.6751 49.0319 48.6213 49.0319 46.3622V6.10762C49.0319 3.84843 47.1835 2 44.719 2H6.31298C3.84844 2 2 3.84843 2 6.10762V46.3622C2 48.6213 3.84844 50.6751 6.31298 50.6751H44.719Z",
    stroke: "#201C1C",
    strokeWidth: 3.93904,
    strokeMiterlimit: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4037 7.13477L33.0126 26.8513V7.13477H43.8977V45.3355H34.2449L17.6091 24.7975V45.3355H7.13477V7.13477H17.4037Z",
    fill: "#201C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNcplogo);
export default __webpack_public_path__ + "static/media/NCPLOGO.61e14efc4e23f12016e12a4909f478ae.svg";
export { ForwardRef as ReactComponent };